import { BackButton, InitAppPage } from '@capsicum/common-web';
import { NCOnboardingRoutesEnum, useNCWOnboardingRoutes } from '@capsicum/features/nc-onboarding/shared';

type VerificationScreenProps = {
	showBackButton?: boolean;
	testID: string;
	title: string;
	VerificationStep: React.ComponentType<{ customBackNavigation: () => void; onSubmit: () => void }>;
};

export const VerificationScreen = ({
	showBackButton = false,
	testID,
	title,
	VerificationStep
}: VerificationScreenProps) => {
	const { goToPage } = useNCWOnboardingRoutes({});
	const goBack = () => goToPage(NCOnboardingRoutesEnum.CONGRATULATIONS);

	const backButtonComponent = showBackButton ? (
		<BackButton testID="ncw-onboarding-verification-screen-back-button" onClick={goBack} />
	) : null;

	return (
		<InitAppPage
			body={<VerificationStep customBackNavigation={goBack} onSubmit={goBack} />}
			testID={testID}
			title={title}
			topBarHeaderLeftComponent={backButtonComponent}
		/>
	);
};
